import React, { useState } from "react";
import styled from "styled-components";
import InputMemberSelectControl from "~/components/InputMemberSelectControl";
import { useTranslation } from "react-i18next";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const MergeMemberForm = _ref => {
  let {
    selectedMemberId,
    control
  } = _ref;
  const [selectedId] = useState(selectedMemberId);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(InputMemberSelectControl, {
    label: t("MergeMemberForm.selectMember"),
    name: "mergeMemberId",
    control: control,
    filterMembers: [selectedId]
  }));
};
export default MergeMemberForm;